import { createSlice } from '@reduxjs/toolkit'
import {
  addStudentToProgram,
  addStudentsToWaitlist,
  removeStudentFromWaitlist,
} from '../actions/waitlistActions'


const initialState = {
  isLoading: false,
  isWaitlistModalOpen: false,
}

const waitlistSlice = createSlice({
  name: 'waitlist',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Add Students to Waitlist
      .addCase(addStudentsToWaitlist.pending, state => {
        state.isLoading = true
      })
      .addCase(addStudentsToWaitlist.rejected, state => {
        state.isLoading = false
      })
      .addCase(addStudentsToWaitlist.fulfilled, state => {
        state.isLoading = false
      })

      // Remove Student from Waitlist
      .addCase(removeStudentFromWaitlist.pending, state => {
        state.isLoading = true
      })
      .addCase(removeStudentFromWaitlist.rejected, state => {
        state.isLoading = false
      })
      .addCase(removeStudentFromWaitlist.fulfilled, state => {
        state.isLoading = false
      })

      // Add Student to Program from Waitlist
      .addCase(addStudentToProgram.pending, state => {
        state.isLoading = true
      })
      .addCase(addStudentToProgram.rejected, state => {
        state.isLoading = false
      })
      .addCase(addStudentToProgram.fulfilled, state => {
        state.isLoading = false
      })
  },
})


export default waitlistSlice.reducer
